<div class="nav-menu dark">
    <ul class="navbar-nav">
        <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionClients]">
            <div class="menu">
                <a class="nav-link" href="#"
                   [routerLink]="['customers']"
                   routerLinkActive
                   #customersLink="routerLinkActive"
                   [ngClass]='{"selected": customersLink.isActive}'>
                    <span translate="client"></span>
                </a>
            </div>
        </li>
        <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionBackoffices]">
            <div class="menu">
                <a class="nav-link" href="#"
                   [routerLink]="['backoffices']"
                   routerLinkActive
                   #backofficesLink="routerLinkActive"
                   [ngClass]='{"selected": backofficesLink.isActive}'>
                    <span translate="administrateur"></span>
                </a>
            </div>
        </li>
    </ul>
</div>

<router-outlet></router-outlet>
